<ng-container
  *ngIf="{
    model: model$ | async,
    products: products$ | async,
    compactMode: compactMode$ | async,
  } as content"
>
  <div class="cx-page">
    <cx-active-facets *smallerThan="DEVICE_SIZE.DESKTOP"></cx-active-facets>

    <section tabindex="-1" class="cx-page-section" [attr.aria-label]="'productList.productListResults' | cxTranslate">
      <div *ngIf="currentViewMode$ | async as viewMode">
        <div id="product-results-list" class="cx-product-container">
          <!-- Product list when using pagination -->
          <ng-container *ngIf="!isInfiniteScroll; else infiniteScroll">
            <div class="row m-t--20">
              <ng-container *ngIf="viewMode === ViewModes.Grid">
                <div *ngFor="let product of content.products" class="col-12 col-sm-6 col-md-4 m-t-20">
                  <cx-product-grid-item [product]="product"></cx-product-grid-item>
                </div>
              </ng-container>

              <ng-container *ngIf="viewMode === ViewModes.List">
                <div *ngFor="let product of content.products" class="col-12 m-t-20">
                  @if (content.compactMode) {
                    <product-list-item-compact [product]="product"></product-list-item-compact>
                  } @else {
                    <cx-product-list-item [product]="product"></cx-product-list-item>
                  }
                </div>
              </ng-container>
            </div>

            <cx-plp-pagination></cx-plp-pagination>
          </ng-container>

          <!-- Product list when using infinite scroll -->
          <ng-template #infiniteScroll>
            <cx-product-scroll
              *ngIf="content.model"
              [scrollConfig]="scrollConfig"
              [model]="content.model"
              [inputViewMode]="viewMode"
            ></cx-product-scroll>
          </ng-template>
        </div>
      </div>
    </section>
  </div>
</ng-container>
